/* Internal dependencies */
import API from '.';

export const getTasteTestForUser = async (userId: string) =>
  await API.get({
    path: `/taste-test/getTasteTestForUser/${userId}`,
  });
